import { toast } from 'react-toastify';
import { AuthConstants } from '../_constants';
import { AuthService } from '../_services';

export const AuthActions = {
  login,
};

function login(userID) {
  return (dispatch) => {
    dispatch(request(userID));

    return AuthService.login(userID).then(
      (user) => {
        // console.log('Action: User is', user);
        dispatch(success(user));
        return user;
      },
      (error) => {
        const message = error.toString();
        console.log(`[Chronos] Error - Authentication: `, message);
        toast.warning(
          `Unable to authenticate. Try making sure you're logged in.`
        );
        dispatch(failure(message));
      }
    );
  };

  function request(params) {
    return {
      type: AuthConstants.LOGIN_REQUEST,
      params,
    };
  }

  function success(payload) {
    return {
      type: AuthConstants.LOGIN_SUCCESS,
      payload,
    };
  }

  function failure(error) {
    return {
      type: AuthConstants.LOGIN_FAILURE,
      error,
    };
  }
}
